(function RegistrationPassengers($, Adzuki)
{
	"use strict";

	var occupancy_request         = null;
	var occupancy_pricing_request = null;

	var form = {
		name: 'GroupRegistrationPassengers',
	};

	$(document).ready(function documentReady() {
		Adzuki.Form.registerForm(form);
	});

	Adzuki.onload('GroupRegistrations/passengers/', init);

	function init()
	{
		$('#groupregistrationpassengers-groupregistrationcomponent-group_component_category_id').on('change', getOccupancies);
		$('#groupregistrationpassengers-groupregistrationcomponent-group_component_category_occupancy_id').on('change', handleOccupancyChange);
		$('.req-air').on('change', handleRequestAir);
		$('.country').on('change', handleCountryChange);
		$('.clear-passenger').on('click', clearPassenger);
		$('.use-primary-address').on('change', usePrimaryAddress);

		// If we're coming back to this page, make sure toggled sections are visible/hidden based on
		// user selections
		$('.req-air').change();

		// If we have a category but no occupancies, get the occupancies
		// This happens when user clicks register now button for specific category
		if ($('#groupregistrationpassengers-groupregistrationcomponent-group_component_category_id').val() !== '') {
			if ($('#groupregistrationpassengers-groupregistrationcomponent-group_component_category_occupancy_id option').length === 1) {
				getOccupancies();
			}
		}

		handleOccupancyChange(); // Show correct passenger sections on load

		$('.country').change();
		$('.use-primary-address').change();
	}

	function getOccupancies()
	{
		var category_id = $('#groupregistrationpassengers-groupregistrationcomponent-group_component_category_id').val().trim();

		if (category_id === '') {
			setOccupancyOptions({});
			return;
		}

		if (occupancy_request !== null) {
			occupancy_request.abort();
			occupancy_request = null;
		}

		occupancy_request = Adzuki.Ajax.get('/GroupRegistrations/getOccupancies/' + category_id);
		occupancy_request.then(function success(data) {
			setOccupancyOptions(data);
		});
	}

	function setOccupancyOptions(occupancies)
	{
		var $el = $('#groupregistrationpassengers-groupregistrationcomponent-group_component_category_occupancy_id');

		$el.empty();

		$.each(occupancies, function parseOccupancies(key, occupancy) {
			$el.append($('<option>').text(occupancy['num_passengers']).attr('value', occupancy['id']));
		});

		$el.change();	// If double occupancy is an option - pre select it
	}

	function handleOccupancyChange()
	{
		var num_passengers = $('#groupregistrationpassengers-groupregistrationcomponent-group_component_category_occupancy_id option:selected').text(),
		    i;

		if (num_passengers > 0) {
			$('#registration-no-passengers').hide();
		} else {
			$('#registration-no-passengers').show();
		}

		// Show the appropriate passenger
		$('.passenger-container').addClass('hidden');
		for (i = 1; i <= num_passengers; i++) {
			$('#category-passenger-' + i).removeClass('hidden');
		}

		if (num_passengers > 0) {
			getCategoryOccupancyPricing();
		} else {
			$('#registration-pricing-container').addClass('hidden');
		}
	}

	function getCategoryOccupancyPricing()
	{
		var category_id  = $('#groupregistrationpassengers-groupregistrationcomponent-group_component_category_id').val();
		var occupancy_id = $('#groupregistrationpassengers-groupregistrationcomponent-group_component_category_occupancy_id').val();

		if ($('#registration-pricing-container').length > 0) {
			if (occupancy_pricing_request !== null) {
				occupancy_pricing_request.abort();
				occupancy_pricing_request = null;
			}

			occupancy_pricing_request = Adzuki.Ajax.get('/GroupRegistrations/categoryOccupancyPricing/' + category_id + '/' + occupancy_id);
			occupancy_pricing_request.then(function success(data) {
				$('#registration-pricing-container').html(data);
				$('#registration-pricing-container').removeClass('hidden');
			});
		}
	}

	function handleRequestAir(ev)
	{
		var pass_num       = $(this).data('pass-num');
		var gateway_row_id = 'air-gateway-row-' + pass_num;

		if ($(this).is(':checked')) {
			$('#' + gateway_row_id).removeClass('hidden');
		} else {
			$('#' + gateway_row_id).addClass('hidden');
		}
	}

	function handleCountryChange(ev)
	{
		var pass_num   = $(this).data('pass-num');
		var country_id = $(this).val();

		// Hide the state and province for this passenger
		$('#category-passenger-' + pass_num + ' .state-row').addClass('hidden');
		$('#category-passenger-' + pass_num + ' .province-row').addClass('hidden');

		if (country_id === '183') {
			$('#category-passenger-' + pass_num + ' .state-row').removeClass('hidden');
		} else if (country_id === '31') {
			$('#category-passenger-' + pass_num + ' .province-row').removeClass('hidden');
		} else if (country_id !== '') {
			// clear out state and province
			$('#groupregistrationpassengers-groupregistrationpassenger-' + pass_num + '-state_id').val('');
			$('#groupregistrationpassengers-groupregistrationpassenger-' + pass_num + '-province').val('');
		}
	}

	function clearPassenger(ev)
	{
		var pass_num = $(this).data('pass-num');

		ev.preventDefault();

		$('#category-passenger-' + pass_num + ' input, #category-passenger-' + pass_num + ' select').each(function clearField(index, el) {
			if (!$(el).hasClass('ignore-clear')) {
				if (el.type === 'checkbox') {
					$(el).prop('checked', false);
				} else if ($(el).hasClass('adzuki-datetimepicker')) {
					$(el).data('DateTimePicker').date(null);
				} else {
					$(el).val('');
				}
			}
		});

		$('#category-passenger-' + pass_num + ' .req-air').change();  // Make sure departure airport hidden
		$('#category-passenger-' + pass_num + ' .country').val('183'); // US is default
	}

	function usePrimaryAddress()
	{
		var pass_num = $(this).data('pass-num');

		if ($(this).is(':checked')) {
			$('#category-passenger-' + pass_num + ' .address-row').addClass('hidden');
		} else {
			$('#category-passenger-' + pass_num + ' .address-row').removeClass('hidden');
			// But we don't want to show province and state
			$('#groupregistrationpassengers-groupregistrationpassenger-' + pass_num + '-country_id').change();
		}
	}

}(jQuery, window.Adzuki || {}));